import React, { type FC } from "react";
import styles from "./ActionBar.module.css";

const { checkboxContainer, checkboxInput, checkboxCount } = styles;

type CheckBoxProps = {
  name: string;
  label: string;
  count: number;
  isRefined: boolean;
};

export const Checkbox: FC<CheckBoxProps> = ({
  name,
  label,
  count,
  isRefined,
}) => {
  return (
    <label className={checkboxContainer}>
      <input
        name={name}
        type="checkbox"
        checked={isRefined}
        onChange={() => true}
        className={checkboxInput}
      />
      <span>{label}</span>
      <span className={checkboxCount}>{count}</span>
    </label>
  );
};
